import {transform} from 'lodash';

// TODO: move to enums
export enum Language {
    Arabic = 'ar',
    English = 'en',
    Spanish = 'es',
    French = 'fr',
    Hebrew = 'he',
    Portuguese = 'pt',
}

export const DEFAULT_LANGUAGE = Language.English;

const LANGUAGE_MAP = transform(Language, (acc, value) => acc[value] = value, {});

export const MOMENT_LOCALE_MAP = {
    ...LANGUAGE_MAP,
    [Language.English]: null
};